import React from 'react'
import { Field, Radio, RadioGroup } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { IRadioOption } from '../../../interfaces/IRadioOptions'
import { t } from '../../../i18n/i18n'

type ControlledRadioGroupProps = {
   name: string
   label: string
   control: Control<any>
   options: IRadioOption[]
   required?: boolean
   disabled?: boolean
   convertValue?: boolean
}

export const ControlledRadioGroup = ({ name, label, control, options, required, disabled, convertValue }: ControlledRadioGroupProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{ validate: (value) => value > 0 || t('RequiredField') }} // value must be greater than 0
         render={({ field, formState: { disabled: formDisabled }, fieldState: { error } }) => (
            <Field label={label} required={required} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
               <RadioGroup
                  disabled={(disabled || formDisabled) ?? false}
                  required={required}
                  onChange={(e, data) => field.onChange(convertValue ? Number(data.value) : data.value)}
               >
                  {options.map((option) => (
                     <Radio value={String(option.value)} label={option.label} checked={field.value === option.value} />
                  ))}
               </RadioGroup>
            </Field>
         )}
      />
   )
}
